import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHotWater = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 94,
	height: 95,
	viewBox: "0 0 94 95",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M44 21.84C40.481 13.571 40.252 9.38699 43.02 3.95999C44.132 1.78199 45.707 0 46.52 0C48.425 0 48.393 0.309 46 5C43.322 10.249 43.466 12.537 47 20.84C50.594 29.286 50.692 31.586 47.812 39.787C45.76 45.63 45.688 46.653 46.794 54.245C48.061 62.936 47.052 66.865 44.953 61.413C42.69 55.533 42.674 44.963 44.919 38.593C47.607 30.965 47.566 30.22 44 21.84Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.798 26.011C29.325 23.372 28.402 20.931 28.747 20.586C29.931 19.402 31.503 20.66 33.734 24.578C36.593 29.599 36.559 32.05 33.512 40.773C31.618 46.193 31.173 48.982 31.648 52.447C32.153 56.13 31.981 57 30.749 57C29.706 57 29.009 55.547 28.534 52.38C27.983 48.701 28.416 46.032 30.659 39.283L33.476 30.808L30.798 26.011Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.621 26.12C60.895 23.321 60.543 20.79 60.838 20.495C62.128 19.206 63.574 21 64.831 25.448C66.253 30.483 65.949 32.617 62.48 42C61.4 44.92 61.015 47.977 61.383 50.706C62.004 55.314 60.709 57.194 59.05 54.094C57.365 50.946 57.822 45.857 60.47 38.278C62.763 31.715 62.846 30.842 61.621 26.12Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.655 47.849C67.552 45.276 67.654 45.368 68.459 44.067C69.331 42.655 69.48 42.68 73.79 44.977C81.024 48.833 84 52.672 84 58.146C84 68.57 69.225 75.5 47 75.5C33.797 75.5 27.96 74.4 19.88 70.391C7.728 64.36 6.576 53.612 17.336 46.636C20.272 44.732 21.692 44.307 22.45 45.104C23.193 45.885 22.922 46.542 21.524 47.354C13.292 52.13 10.796 58.887 15.518 63.609C27.707 75.798 66.293 75.798 78.482 63.609C83.345 58.746 80.842 51.977 72.655 47.849Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.627 73.178C2.714 70.463 0 65.328 0 62.532C0 61.689 0.675 61 1.5 61C2.325 61 3 61.494 3 62.099C3 65.014 6.701 70.386 10.519 73.013C12.856 74.621 18.307 77.179 22.634 78.697C30 81.283 31.549 81.459 47 81.459C62.451 81.459 64 81.283 71.366 78.697C75.693 77.179 81.144 74.621 83.481 73.013C87.299 70.386 91 65.014 91 62.099C91 61.494 91.675 61 92.5 61C94.368 61 94.409 63.107 92.623 67.282C90.808 71.525 86.682 75.266 80.298 78.457C58.642 89.281 19.969 86.548 5.627 73.178Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.288 84C84.278 84 84.739 82.864 88.196 79.298C91.672 75.712 92.503 75.386 93.61 77.177C94.403 78.461 88.459 84 86.288 84Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.965 88C8.874 88 8.64601 84.687 9.66701 83.667C10.478 82.855 13 82.779 13 83.566C13 84.868 10.856 88 9.965 88Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.913 90.554C17.19 91.619 16.127 89.712 17.072 87.25C17.547 86.012 18.4 85 18.968 85C20.343 85 20.296 89.699 18.913 90.554Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 90.75C25 89.421 25.3 88.033 25.667 87.667C27.123 86.21 28.117 87.138 27.816 89.673C27.409 93.117 25 94.038 25 90.75Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54 91.377C58.675 90.759 63.4 90.024 64.5 89.743C68.519 88.716 72.177 88.97 71.752 90.245C71.186 91.943 62.03 93.924 53.285 94.24C43.185 94.604 43.65 92.745 54 91.377Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgHotWater);
export { ForwardRef as ReactComponent };
